import { render, staticRenderFns } from "./ControlPagoDocentePorEmpresaTab.vue?vue&type=template&id=31f7ae1e&scoped=true"
import script from "./ControlPagoDocentePorEmpresaTab.vue?vue&type=script&lang=js"
export * from "./ControlPagoDocentePorEmpresaTab.vue?vue&type=script&lang=js"
import style0 from "./ControlPagoDocentePorEmpresaTab.vue?vue&type=style&index=0&id=31f7ae1e&prod&lang=css"
import style1 from "./ControlPagoDocentePorEmpresaTab.vue?vue&type=style&index=1&id=31f7ae1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f7ae1e",
  null
  
)

export default component.exports